import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Navbar from '../../components/Navbar/Navbar';
import Practice from '../../components/Practice/index';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
//import Features from '../../components/Features/Features';
//import Newsletter from '../../components/Newsletter/Newsletter';
//import Pricing from '../../components/Pricing/Pricing';

const PracticePage = () => {
	return (
		<Fragment>
			<Navbar />
			<PageTitle pageTitle={'Matières'} pagesub={'Matières'} />
			<Practice />
			<Footer />
			<Scrollbar />
		</Fragment>
	);
};
export default PracticePage;
